import 'bootstrap';
import '@hotwired/turbo-rails';

import gaPageView from 'src/ui/components/google_analytics';
import rolexPageView from 'src/ui/components/rolex_analytics';
import setupUserWay from 'src/ui/components/user_way';

// stimulus app:
import 'src/ui/stimulus';

// require('@rails/activestorage').start();
// require('channels');

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// require('@fortawesome/fontawesome-free');

// analytics tracking:
gaPageView();
rolexPageView();

// user way widget needs:
setupUserWay();
